module.exports = __webpack_public_path__ + "media/images/registration_papers-e102900eeef75ef31cfbb6d0c3109626.jpeg";